import React, { ReactElement } from 'react';

const ChevronDown = (): ReactElement => (
    <path fillRule="evenodd" clipRule="evenodd" d="M58.8876 14.1124C57.214 12.4387 54.5004 12.4387 52.8267 14.1124L30.1429 36.7962L7.45905 14.1124C5.78538 12.4387 3.07181 12.4387 1.39814 14.1124C-0.275536 15.7861 -0.275536 18.4996 1.39814 20.1733L27.1124 45.8876C28.7861 47.5613 31.4997 47.5613 33.1733 45.8876L58.8876 20.1733C60.5613 18.4996 60.5613 15.7861 58.8876 14.1124Z" />
);

export default ChevronDown;
